@if (isTaskLoaded) {
  @for (tnmd of task_nav_move_display; track tnmd.move) {
    @if (task_nav_move_abilities[tnmd.move]) {
      <div class="task-nav-hotzone task-nav-hotzone--{{ tnmd.move }}">
        <button mat-icon-button class="task-nav-arrow" (click)="goToTask(tnmd.move)">
          <mat-icon>{{ tnmd.icon }}</mat-icon>
        </button>
      </div>
    }
  }
  <div class="task-detail-layout">
    <div mat-dialog-title>
      <section id="issue-type">
        <div class="task-code" (click)="copyTaskCodeToClipboard()" matTooltip="Copiar 📋">
          <img class="task-type" [src]="task.type | productTaskTypeImage" />
          <span class="code">{{ task.code }}</span>
        </div>
      </section>
      <section id="issue-options">
        <section id="issue-options-buttons">
          @if (user_permissions().can_edit_backlog) {
            <button mat-stroked-button color="warn" (click)="openIssue()" style="margin-left: 10px; position: relative">
              <mat-icon>add_circle</mat-icon>
              Abrir issue
            </button>
          }

          @if (task.type === ProductTaskTypeEnum.ISSUE && !task.is_archived && canArchiveOrDelete) {
            <button mat-stroked-button color="warn" (click)="archive()" style="margin-left: 10px">
              <mat-icon>archive</mat-icon>
              Cerrar issue
              <mat-icon
                iconPositionEnd
                class="cerrar-issue-info-icon"
                matTooltip="Cierra una issue cuando finalmente no ha sido una issue y no hay que hacer nada. Sobretodo, no la completes."
                (click)="$event.stopPropagation()"
              >
                info
              </mat-icon>
            </button>
          }

          <app-company-product-github-pull-request-link [task_code]="task.code" [company_product_id]="company_product_id" />

          <button (click)="openDesignLinksCrudDialog()" mat-icon-button [matTooltip]="'Enlaces diseño'" style="position: relative">
            <mat-icon>palette</mat-icon>

            @if (task.product_task_design_links.length > 0 || (task.product_task_design_links_count ?? 0) > 0) {
              <span class="design-link-crud-span-btn">
                {{
                  task.product_task_design_links.length > 0
                    ? task.product_task_design_links.length
                    : (task.product_task_design_links_count ?? 0)
                }}
              </span>
            }
          </button>

          <button mat-icon-button (click)="copyLink()" [matTooltip]="'Copiar link a la tarea'">
            <mat-icon>link</mat-icon>
          </button>

          @if (
            !task.is_completed &&
            product_task_board() !== null &&
            currentBoard !== null &&
            user_permissions().can_edit_board &&
            canArchiveOrDelete
          ) {
            <button (click)="removeFromBoard()" mat-icon-button [matTooltip]="'Borrar tarea del tablero'">
              <mat-icon>do_not_disturb_on</mat-icon>
            </button>

            @if (task.is_archived) {
              <button (click)="unarchive()" mat-icon-button [matTooltip]="'Desarchivar tarea'">
                <mat-icon>unarchive</mat-icon>
              </button>
            } @else if (task.type !== ProductTaskTypeEnum.ISSUE) {
              <button (click)="archive()" mat-icon-button [matTooltip]="'Archivar tarea'">
                <mat-icon>archive</mat-icon>
              </button>
            }
          }

          <button mat-icon-button (click)="close()">
            <mat-icon>close</mat-icon>
          </button>
        </section>
      </section>
    </div>
    <div class="task-detail-scroll">
      <mat-dialog-content>
        <ngx-dropzone (change)="onDragFile($event)" [disableClick]="true" [maxFileSize]="attachment_max_file_size_bytes">
          <section id="issue-body" class="row">
            <section id="issue-content" class="col-12 col-md-8">
              @if (editingField !== 'title') {
                <div (click)="setEditingField('title')" id="title-container">
                  <h1>{{ task.title }}</h1>
                </div>
              }
              @if (editingField === 'title') {
                <div id="title-container" class="position-relative">
                  <mat-form-field
                    class="w-100 nobottom"
                    style="font-size: 1rem; font-family: 'Playfair Display', sans-serif; font-weight: 700"
                    appearance="outline"
                  >
                    <input
                      #editingInput
                      (keydown.enter)="updateTask()"
                      type="text"
                      [ngModel]="task.title"
                      (ngModelChange)="task.title = $event"
                      (onClick)="setEditingFieldOriginalValue(task.description, 'title')"
                      form
                      placeholder="Título de tarea"
                      matInput
                    />
                  </mat-form-field>
                  <section class="action-buttons position-absolute end-0">
                    <button color="primary" (click)="updateTask()">
                      <mat-icon>check</mat-icon>
                    </button>
                    <button color="warn" (click)="setEditingField('')">
                      <mat-icon>close</mat-icon>
                    </button>
                  </section>
                </div>
              }
              <div id="description-container">
                <div class="content-label">Descripción</div>
                @if (editingField !== 'description' && task.description !== null) {
                  <div [innerHTML]="task.description" (click)="onTaskRichContentClick($event, 'description')" class="description"></div>
                }
                @if (editingField !== 'description' && task.description === null) {
                  <div class="placeholders description" (click)="setEditingField('description')">
                    Añade una descripción más detallada...
                  </div>
                }
                @if (editingField === 'description') {
                  <div>
                    <editor
                      [apiKey]="tinyMceApiKey"
                      [ngModel]="task.description"
                      (ngModelChange)="task.description = $event"
                      cloudChannel="6"
                      [disabled]="false"
                      id="description-editor"
                      [init]="tinyMceInit"
                      (onClick)="setEditingFieldOriginalValue(task.description, 'description')"
                      initialValue=""
                      [inline]="false"
                      tagName="div"
                      plugins="anchor autolink charmap codesample directionality help image insertdatetime link lists media nonbreaking pagebreak searchreplace table visualblocks visualchars wordcount advlist autolink lists link image charmap preview anchor searchreplace visualblocks code fullscreen insertdatetime media table emoticons codesample"
                      toolbar="undo redo spellcheckdialog | blocks fontfamily fontsize | codesample | bold italic underline strikethrough | forecolor backcolor | insertfile link image | align lineheight checklist bullist numlist | indent outdent | removeformat typography | table tabledelete | tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol"
                    >
                    </editor>
                    <div class="editorButtons">
                      <button (click)="updateTask()" class="save">Guardar</button>
                      <button (click)="setEditingField('')" class="cancel">Cancelar</button>
                    </div>
                  </div>
                }
              </div>
              <div class="dropzone-image-preview" (click)="$event.stopPropagation()">
                @for (attachedFile of task.attachments; track attachedFile.id) {
                  <div
                    class="attachment"
                    [class.attachment-previewable]="attachedFile.can_preview"
                    (mouseenter)="hoveringAttachedFile = attachedFile.id"
                    (click)="onAttachmentClick($event, attachedFile)"
                  >
                    @if (attachedFile.is_image) {
                      <img [src]="attachedFile.file_path" [alt]="attachedFile.file_name" />
                    } @else if (attachedFile.is_video) {
                      @if (attachedFile.is_browser_playable) {
                        <video [src]="attachedFile.file_path" muted playsinline preload="metadata"></video>
                      } @else {
                        <div class="attached-file attached-video">
                          <mat-icon>movie</mat-icon>
                        </div>
                      }
                    } @else if (attachedFile.is_audio) {
                      <div class="attached-file attached-audio">
                        <mat-icon>audiotrack</mat-icon>
                      </div>
                    } @else {
                      <div class="attached-file" [ngClass]="'attached-' + getFileNameExtension(attachedFile.file_name)">
                        @if (checkIfFileCanBeDisplayed(attachedFile.file_name)) {
                          <iframe [src]="attachedFile.file_path_sanitized" frameborder="0"></iframe>
                        }
                      </div>
                    }
                    <div class="attachment-label">
                      {{ attachedFile.file_name.length > 15 ? (attachedFile.file_name | slice: 0 : 15) + '..' : attachedFile.file_name }}
                    </div>
                    @if (hoveringAttachedFile === attachedFile.id) {
                      <div class="attachment-actions" (click)="$event.stopPropagation()">
                        <a href="{{ attachedFile.file_path }}" target="_blank">
                          <button mat-icon-button>
                            <mat-icon>get_app</mat-icon>
                          </button>
                        </a>
                        @if (user_permissions().can_edit_backlog) {
                          <button (click)="deleteAttachedFile(attachedFile)" mat-icon-button>
                            <mat-icon>close</mat-icon>
                          </button>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
              <div id="activity-container">
                <div class="content-label">Actividad</div>
                <div class="activity">
                  <header class="activity-header">
                    <div class="activity-label">Ver:</div>
                    <div class="activity-filter">
                      <button [ngClass]="{ active: activeActivityMenu === 'all' }" (click)="onActivityMenuChange('all')">Todo</button>
                      <button [ngClass]="{ active: activeActivityMenu === 'comments' }" (click)="onActivityMenuChange('comments')">
                        Comentarios
                      </button>
                      <button [ngClass]="{ active: activeActivityMenu === 'history' }" (click)="onActivityMenuChange('history')">
                        Historial
                      </button>
                      <button [ngClass]="{ active: activeActivityMenu === 'worklog' }" (click)="onActivityMenuChange('worklog')">
                        Registro de trabajo
                      </button>
                      <button [ngClass]="{ active: activeActivityMenu === 'distribution' }" (click)="onActivityMenuChange('distribution')">
                        Distribución
                      </button>
                      <button [ngClass]="{ active: activeActivityMenu === 'deploys' }" (click)="onDeploysMenuClick()">Despliegues</button>
                    </div>
                  </header>
                  <section class="activity-body">
                    @if (activeActivityMenu === 'comments' || activeActivityMenu === 'all') {
                      <section id="comments">
                        @if (commentsFragmentLoading) {
                          <div class="d-flex justify-content-center p-3">
                            <mat-progress-spinner diameter="32" mode="indeterminate"></mat-progress-spinner>
                          </div>
                        }
                        @if (editingField !== 'creatingComment') {
                          <section id="add-comment">
                            <app-user-profile-picture [user]="me" [css_class]="'profile-image'" />
                            <textarea
                              (click)="setEditingField('creatingComment')"
                              class="comment-input"
                              placeholder="Añade un comentario..."
                              [disabled]="is_current_board_old_and_inactive"
                            ></textarea>
                          </section>
                        }
                        @if (editingField === 'creatingComment') {
                          <section class="new-comment">
                            <section id="add-comment">
                              <app-user-profile-picture [user]="me" [css_class]="'profile-image'" />
                              <editor
                                [apiKey]="tinyMceApiKey"
                                [ngModel]="newComment"
                                (ngModelChange)="newComment = $event"
                                cloudChannel="6"
                                [disabled]="false"
                                id="new-comment-editor"
                                [init]="{
                                  automatic_uploads: true,
                                  statusbar: false,
                                  menubar: false,
                                  file_picker_types: 'file image media',
                                  auto_focus: true,
                                }"
                                initialValue=""
                                [inline]="false"
                                tagName="div"
                                plugins="anchor autolink charmap codesample directionality help image insertdatetime link lists media nonbreaking pagebreak searchreplace table visualblocks visualchars wordcount advlist autolink lists link image charmap preview anchor searchreplace visualblocks code fullscreen insertdatetime media table emoticons codesample"
                                toolbar="undo redo spellcheckdialog | blocks fontfamily fontsize | codesample | bold italic underline strikethrough | forecolor backcolor | insertfile link image | align lineheight checklist bullist numlist | indent outdent | removeformat typography | table tabledelete | tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol"
                              >
                              </editor>
                            </section>
                            <div class="editorButtons">
                              <button (click)="createComment()" class="save" [disabled]="is_saving_comment()">Guardar</button>
                              <button (click)="editingField = ''" class="cancel" [disabled]="is_saving_comment()">Cancelar</button>
                            </div>
                          </section>
                        }
                        @for (comment of task.comments; track comment.id) {
                          <div class="activity-entry">
                            <app-user-profile-picture [user]="comment.user" [css_class]="'profile-image'" />
                            @if (!editingComment || editingComment.id !== comment.id) {
                              <div class="activity-detail">
                                <header>
                                  <div class="activity-user-name">
                                    {{ comment.user.name + ' ' + comment.user.surnames }}
                                  </div>
                                  <div class="activity-user-role">
                                    {{ comment.author_role }}
                                  </div>
                                  <div class="activity-detail-date">
                                    {{ comment.updated_at | dateAgo }}
                                  </div>
                                  @if (comment.origin === ProductTaskCommentOriginEnum.DEADLOCK_IN) {
                                    <span class="comment-origin-tag" matTooltip="Deadlock in" aria-label="deadlock in">🔒 In</span>
                                  } @else if (comment.origin === ProductTaskCommentOriginEnum.DEADLOCK_OUT) {
                                    <span class="comment-origin-tag" matTooltip="Deadlock out" aria-label="deadlock out">🔓 Out</span>
                                  }
                                </header>
                                <div
                                  class="body"
                                  [class.preserve_newlines]="
                                    comment.origin === ProductTaskCommentOriginEnum.DEADLOCK_IN ||
                                    comment.origin === ProductTaskCommentOriginEnum.DEADLOCK_OUT
                                  "
                                  [innerHTML]="comment.content"
                                  (click)="onTaskRichContentClick($event)"
                                ></div>
                                @if (comment.user_id === me.id) {
                                  <footer>
                                    <button (click)="setEdittingComment(comment)">
                                      <span>Editar</span>
                                    </button>
                                    ·
                                    <button (click)="deleteComment(comment)">
                                      <span>Borrar</span>
                                    </button>
                                  </footer>
                                }
                              </div>
                            }
                            @if (editingComment && editingComment.id === comment.id) {
                              <div class="activity-detail">
                                <editor
                                  [apiKey]="tinyMceApiKey"
                                  [ngModel]="editingComment.content"
                                  (ngModelChange)="editingComment.content = $event"
                                  cloudChannel="6"
                                  [disabled]="false"
                                  id="new-comment-editor"
                                  [init]="{
                                    automatic_uploads: true,
                                    statusbar: false,
                                    menubar: false,
                                    file_picker_types: 'file image media',
                                    auto_focus: true,
                                  }"
                                  initialValue=""
                                  [inline]="false"
                                  tagName="div"
                                  plugins="anchor autolink charmap codesample directionality help image insertdatetime link lists media nonbreaking pagebreak searchreplace table visualblocks visualchars wordcount advlist autolink lists link image charmap preview anchor searchreplace visualblocks code fullscreen insertdatetime media table emoticons codesample"
                                  toolbar="undo redo spellcheckdialog | blocks fontfamily fontsize | codesample | bold italic underline strikethrough | forecolor backcolor | insertfile link image | align lineheight checklist bullist numlist | indent outdent | removeformat typography | table tabledelete | tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol"
                                >
                                </editor>
                                <div class="editorButtons">
                                  <button (click)="updateComment(editingComment)" class="save" [disabled]="is_saving_comment()">
                                    Guardar
                                  </button>
                                  <button (click)="this.editingComment = null" class="cancel" [disabled]="is_saving_comment()">
                                    Cancelar
                                  </button>
                                </div>
                              </div>
                            }
                          </div>
                        }
                      </section>
                    }
                    @if (activeActivityMenu === 'worklog' || activeActivityMenu === 'all') {
                      <section id="worklog">
                        @for (worklog of task.ro_working_times; track worklog) {
                          <div class="activity-entry">
                            <app-user-profile-picture [user]="worklog.user" [css_class]="'profile-image'" />
                            <div class="activity-detail">
                              <p style="margin-bottom: 5px">
                                <span class="activity-user-name">{{ worklog.user.name + ' ' + worklog.user.surnames }}</span>
                                <span class="activity-detail-title">
                                  ha registrado
                                  {{ worklog.duration_in_seconds_real | secondsToStringTime }}
                                  {{
                                    worklog.duration_in_seconds_real !== worklog.duration_in_seconds_for_client
                                      ? '(de las cuales ' + (worklog.duration_in_seconds_for_client | secondsToStringTime) + ' productivas)'
                                      : ''
                                  }}
                                  de
                                  {{ worklog.activity_category_display }},
                                </span>
                                <span class="activity-detail-date">{{ worklog.updated_at | dateAgo }}</span>
                              </p>
                              <div class="body preserve_newlines">
                                {{ worklog.description | stripHtmlPipe }}
                              </div>
                              @if (worklog.can_edit_or_delete) {
                                <footer>
                                  <button (click)="openTimeTrackingDialog(worklog, undefined)">
                                    <span>Editar</span>
                                  </button>
                                  ·
                                  <button (click)="deleteWorkingTime(worklog)">
                                    <span>Borrar</span>
                                  </button>
                                </footer>
                              }
                            </div>
                          </div>
                        }
                      </section>
                    }
                    @if (activeActivityMenu === 'history' || activeActivityMenu === 'all') {
                      <section id="history">
                        @if (historyFragmentLoading) {
                          <div class="d-flex justify-content-center p-3">
                            <mat-progress-spinner diameter="32" mode="indeterminate"></mat-progress-spinner>
                          </div>
                        }
                        @for (history_log of historyLogs; track history_log.id) {
                          <div class="activity-entry">
                            <app-user-profile-picture [user]="history_log.user" [css_class]="'profile-image'" />
                            <div class="activity-detail">
                              <header>
                                <div class="activity-user-name">
                                  {{ history_log.user.name + ' ' + history_log.user.surnames }}
                                </div>
                                <div class="activity-detail-title">
                                  {{ history_log.type | productTaskHistoryLogFieldPipe }}
                                </div>
                                <div class="activity-detail-date">
                                  {{ history_log.updated_at | dateAgo }}
                                </div>
                              </header>
                              <div class="body">
                                @if (history_log.old_value) {
                                  <div class="old-wrapper">
                                    <div class="old_value value">
                                      {{
                                        (history_log.old_value.length > 65
                                          ? (history_log.old_value | slice: 0 : 65) + '..'
                                          : history_log.old_value
                                        ) | stripHtmlPipe
                                      }}
                                    </div>
                                    <div class="right_arrow"></div>
                                  </div>
                                }
                                @if (history_log.new_value) {
                                  <div class="new_value value">
                                    {{
                                      (history_log.new_value.length > 65
                                        ? (history_log.new_value | slice: 0 : 65) + '..'
                                        : history_log.new_value
                                      ) | stripHtmlPipe
                                    }}
                                  </div>
                                }
                                @if (history_log.product_task_decline_reasons?.length) {
                                  @for (decline of history_log.product_task_decline_reasons; track decline) {
                                    <div class="value" style="background-color: rgb(235, 109, 109); color: rgb(103, 4, 4)">
                                      {{ decline.message }}
                                    </div>
                                  }
                                }
                              </div>
                            </div>
                          </div>
                        }
                      </section>
                    }
                    @if (activeActivityMenu === 'deploys' || activeActivityMenu === 'all') {
                      <section id="deploys">
                        @if (!taskDeploys || taskDeploys.length === 0) {
                          <p>No hay despliegues relacionados con esta tarea.</p>
                        } @else {
                          <ul style="list-style: none; padding: 0">
                            @for (deploy of taskDeploys; track deploy.id) {
                              <li style="padding: 10px; border-bottom: 1px solid #eee">
                                <div style="display: flex; justify-content: space-between; align-items: center">
                                  <div>
                                    <strong>{{ deploy.application_environment?.role }}</strong>
                                    <span style="margin-left: 10px">{{ deploy.head_branch }}</span>
                                    @if (deploy.tag) {
                                      <span style="margin-left: 10px">({{ deploy.tag }})</span>
                                    }
                                    <div style="margin-top: 5px; font-size: 0.9em; color: #666">
                                      {{ deploy.created_at | date: 'short' }} - {{ deploy.user?.full_name || 'Desconocido' }}
                                    </div>
                                  </div>
                                  <div style="display: flex; align-items: center; gap: 10px">
                                    <mat-chip [class]="getStatusChipClass(deploy.status)">
                                      {{
                                        deploy.status === 'success'
                                          ? 'Exitoso'
                                          : deploy.status === 'failure'
                                            ? 'Fallido'
                                            : deploy.status === 'running'
                                              ? 'En ejecución'
                                              : deploy.status === 'pending'
                                                ? 'Pendiente'
                                                : 'Cancelado'
                                      }}
                                    </mat-chip>
                                  </div>
                                </div>
                              </li>
                            }
                          </ul>
                        }
                      </section>
                    }

                    @if (activeActivityMenu === 'distribution') {
                      <section id="distribution">
                        @if (distributionFragmentLoading) {
                          <div class="d-flex justify-content-center p-3">
                            <mat-progress-spinner diameter="32" mode="indeterminate"></mat-progress-spinner>
                          </div>
                        }
                        @if (
                          !distributionFragmentLoading &&
                          distribution_table != null &&
                          distribution_table.boards != null &&
                          distribution_table.boards.length
                        ) {
                          <div class="table">
                            <div class="row">
                              <div class="cell"></div>
                              @for (col of distribution_table.general.categories; track col) {
                                <div class="cell">{{ col.title }}</div>
                              }
                            </div>
                            <!-- General -->
                            <ng-container
                              *ngTemplateOutlet="distributionTableRowTemplate; context: { $implicit: distribution_table.general }"
                            ></ng-container>
                            <!-- Asignado -->
                            <ng-container
                              *ngTemplateOutlet="distributionTableRowTemplate; context: { $implicit: distribution_table.assigned }"
                            ></ng-container>
                            <!-- Boards -->
                            @for (row of distribution_table.boards; track row) {
                              <ng-container *ngTemplateOutlet="distributionTableRowTemplate; context: { $implicit: row }"></ng-container>
                            }

                            <ng-template #distributionTableRowTemplate let-row>
                              <div class="row">
                                <div
                                  class="cell"
                                  [ngClass]="{ bold: row.bold_title }"
                                  [matTooltip]="
                                    row.from != null
                                      ? 'El tablero empieza en ' +
                                        (row.from | date: 'shortDate') +
                                        ' y finaliza en ' +
                                        (row.to | date: 'shortDate') +
                                        '.'
                                      : 'No hay fecha de inicio en este tablero.'
                                  "
                                >
                                  {{ row.title }}
                                </div>
                                @for (col of row.categories; track col) {
                                  <div class="cell">
                                    <div class="spinner">
                                      <mat-progress-spinner
                                        [value]="getProgressSpinnerDistributionTableValue(col)"
                                        [diameter]="60"
                                        [ngClass]="getProgressSpinnerDistributionTableClassList(col)"
                                      ></mat-progress-spinner>
                                      <span>
                                        {{ col.time_done / 3600 | number: '1.0-0' }}/{{ col.time_to_do / 3600 | number: '1.0-0' }}
                                      </span>
                                    </div>
                                  </div>
                                }
                              </div>
                            </ng-template>
                          </div>
                        }
                      </section>
                    }
                  </section>
                </div>
              </div>
            </section>
            <aside id="issue-sidebar" class="col-12 col-md-4">
              @if (task.is_draft) {
                <div class="row">
                  <div class="col-12">
                    <div id="draft-panel">
                      <p>Esta tarea está en <b>borrador</b>.</p>
                      @if (canPublishTask()) {
                        <button mat-flat-button color="accent" (click)="publishTask()">Publicar tarea</button>
                      } @else if (
                        user_permissions().can_only_create_issues &&
                        (task.type === ProductTaskTypeEnum.STORY || task.type === ProductTaskTypeEnum.TASK)
                      ) {
                        <p>
                          <i>Solo el Product Manager puede publicar historias y tareas.</i>
                        </p>
                      } @else {
                        <p>
                          <i>No tienes permisos para publicar la tarea.</i>
                        </p>
                      }
                    </div>
                  </div>
                </div>
              }
              <div class="row mb-0">
                @if (currentBoard != null && product_task_board() != null) {
                  <div class="col-sm-auto">
                    <div id="column-selector">
                      <mat-select
                        [ngModel]="product_task_board()!.company_product_phase_board_col_id"
                        (ngModelChange)="changeColumn($event)"
                        [disabled]="task.is_completed || is_task_column_selector_disabled"
                        panelWidth
                      >
                        @for (col of currentBoard.company_product_phase_board_cols; track col.id) {
                          <mat-option [value]="col.id" [disabled]="isColumnDisabled(col)">
                            {{ col.title }}
                          </mat-option>
                        }
                      </mat-select>
                    </div>
                  </div>
                }
              </div>
              <div class="row mb-0">
                <div
                  class="col"
                  id="little-selectors"
                  [ngClass]="{
                    horizontal: currentBoard == null || product_task_board() == null,
                  }"
                >
                  <mat-form-field class="task-item-selector nobottom w-100">
                    <mat-select [value]="task.type" #selectedType [disabled]="true">
                      <mat-select-trigger class="selected-task-item">
                        <div class="{{ selectedType.value }}"></div>
                        <div class="task-item-name">
                          {{ selectedType.value | productTaskTypeFieldPipe }}
                        </div>
                      </mat-select-trigger>
                      @for (v of ['issue', 'story', 'task']; track v) {
                        <mat-option [value]="v" [matTooltip]="v | productTaskTypeDescriptionPipe">
                          <div class="task-item-option">
                            <img class="task-item-icon" [src]="v | productTaskTypeImage" />
                            <span>{{ v | productTaskTypeFieldPipe }}</span>
                          </div>
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field class="task-item-selector nobottom w-100">
                    <mat-select
                      [value]="task.priority"
                      #selectedPriority
                      [disabled]="task.is_completed || is_current_board_old_and_inactive || !user_permissions().can_edit_backlog"
                    >
                      <mat-select-trigger class="selected-task-item">
                        <div class="{{ selectedPriority.value }}"></div>
                        <div class="task-item-name">
                          {{ selectedPriority.value | productTaskPriorityFieldPipe }}
                        </div>
                      </mat-select-trigger>
                      <mat-option
                        value="critical"
                        (click)="chooseNewPriority('critical')"
                        [matTooltip]="'Para hacer ya, parando todo lo demás, aunque no haya tiempo, y ya se compensará.'"
                      >
                        <div class="task-item-option">
                          <img class="task-item-icon" src="assets/img/icons/priority/critical.png" />
                          <span>Crítica</span>
                        </div>
                      </mat-option>
                      <mat-option
                        value="high"
                        (click)="chooseNewPriority('high')"
                        [matTooltip]="'Para hacer a ritmo normal, pero parando las demás tareas y priorizando esta.'"
                      >
                        <div class="task-item-option">
                          <img class="task-item-icon" src="assets/img/icons/priority/high.png" />
                          <span>Alta</span>
                        </div>
                      </mat-option>
                      <mat-option value="medium" (click)="chooseNewPriority('medium')" [matTooltip]="'Para hacer a ritmo normal'">
                        <div class="task-item-option">
                          <img class="task-item-icon" src="assets/img/icons/priority/medium.png" />
                          <span>Media</span>
                        </div>
                      </mat-option>
                      <mat-option
                        value="low"
                        (click)="chooseNewPriority('low')"
                        [matTooltip]="'Para hacer cuando se terminen las demás tareas'"
                      >
                        <div class="task-item-option">
                          <img class="task-item-icon" src="assets/img/icons/priority/low.png" />
                          <span>Baja</span>
                        </div>
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  @if (company_product_epics) {
                    <mat-form-field class="task-item-selector nobottom w-100">
                      <mat-select
                        (selectionChange)="changeCompanyProductEpic($event.value)"
                        [value]="task.company_product_epic_id"
                        [disabled]="task.is_completed || is_current_board_old_and_inactive || !user_permissions().can_edit_backlog"
                        panelWidth="360px"
                      >
                        <mat-select-trigger>
                          <img [src]="'assets/img/icons/epic_icon.svg'" />
                          @if (task.company_product_epic) {
                            {{ task.company_product_epic.name }}
                          } @else {
                            Sin Epic
                          }
                        </mat-select-trigger>

                        @if (task.company_product_epic_id) {
                          <mat-option (click)="detachCompanyProductEpic()">
                            <mat-icon>delete</mat-icon>
                            Quitar Epic...
                          </mat-option>
                        }
                        <mat-option (click)="onClickCreateNewEpic()">
                          <mat-icon>add</mat-icon>
                          Crear nuevo Epic...
                        </mat-option>

                        @if (company_product_epics.length > 0) {
                          <mat-divider></mat-divider>
                        }

                        @for (epic of company_product_epics; track epic.id) {
                          <mat-option [value]="epic.id">
                            <img [src]="'assets/img/icons/epic_icon.svg'" />
                            {{ epic.name }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  }
                  <mat-form-field class="task-item-selector nobottom w-100">
                    <mat-select
                      [value]="ui_product_task_origin_category_id"
                      [disabled]="
                        task.is_completed ||
                        is_current_board_old_and_inactive ||
                        !user_permissions().can_edit_backlog ||
                        initial_snapshot_product_task_origin_category_id !== null
                      "
                      (selectionChange)="updateProductTaskOriginCategory($event.value)"
                    >
                      <mat-option [value]="null">—</mat-option>

                      @for (cat of filtered_origin_categories; track cat.id) {
                        <mat-option [value]="cat.id" [matTooltip]="cat.description ?? ''">{{ cat.name }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <hr />
              <div class="row mb-0">
                <div class="col-6 d-flex justify-center align-center">
                  <mat-checkbox
                    [ngModel]="task.is_hotfix"
                    (ngModelChange)="task.is_hotfix = $event"
                    (change)="updateTask(null, 'is_hotfix')"
                    [disabled]="task.is_completed || is_current_board_old_and_inactive || !user_permissions().can_edit_backlog"
                  >
                    Hotfix
                  </mat-checkbox>
                </div>
                <div class="col-6 d-flex justify-center align-center">
                  <mat-checkbox
                    [ngModel]="task.needs_testing"
                    (ngModelChange)="task.needs_testing = $event"
                    (change)="updateTask(null, 'needs_testing')"
                    [disabled]="task.is_completed || is_current_board_old_and_inactive || !user_permissions().can_edit_backlog"
                  >
                    Testing
                  </mat-checkbox>
                </div>
              </div>

              @if (task.product_task_issue_origins?.length) {
                <hr />
                <div class="row mb-0">
                  <div class="col-12">
                    Derivada de:
                    <ul style="list-style: none; margin: 0; padding: 0">
                      @for (origin of task.product_task_issue_origins; track origin.id) {
                        @if (origin.origin_product_task) {
                          <li>
                            <span style="margin: 0; display: flex; align-items: center; gap: 4px">
                              <div [ngClass]="origin.origin_product_task.type" style="display: inline-block"></div>
                              <span class="code" style="font-size: 12px; color: var(--grey_text_color); margin-right: 5px">{{
                                origin.origin_product_task.code
                              }}</span>
                              <span
                                class="task-title"
                                style="font-size: 14px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis"
                                >{{ origin.origin_product_task.title }}</span
                              >
                              @if (origin.agent_reason) {
                                <button
                                  mat-icon-button
                                  type="button"
                                  matTooltip="Ver motivo del agente"
                                  (click)="openIssueOriginAgentReasonDialog(origin)"
                                  style="width: 28px; height: 28px; line-height: 28px"
                                >
                                  <mat-icon style="font-size: 18px; width: 18px; height: 18px">visibility</mat-icon>
                                </button>
                              }
                            </span>
                          </li>
                        }
                      }
                    </ul>
                  </div>
                </div>
              }
              @if (task.originated_issue_origins?.length) {
                <hr />
                <div class="row mb-0">
                  <div class="col-12">
                    Issues abiertas:
                    <ul style="list-style: none; margin: 0; padding: 0">
                      @for (origin of task.originated_issue_origins; track origin.id) {
                        @if (origin.issue_product_task) {
                          <li>
                            <span style="margin: 0; display: flex; align-items: center">
                              <div [ngClass]="origin.issue_product_task.type" style="display: inline-block"></div>
                              <span class="code" style="font-size: 12px; color: var(--grey_text_color); margin-right: 5px">{{
                                origin.issue_product_task.code
                              }}</span>
                              <span
                                class="task-title"
                                style="font-size: 14px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis"
                                >{{ origin.issue_product_task.title }}</span
                              >
                            </span>
                          </li>
                        }
                      }
                    </ul>
                  </div>
                </div>
              }

              <hr />
              <div class="row mb-0">
                <div class="col">
                  <div class="header">
                    <h5 class="label" style="display: flex; align-items: center; margin: 0">
                      Trabajo a realizar
                      @if (task.is_completed) {
                        <mat-chip color="success" size="small" style="margin-left: 5px">
                          <mat-icon style="margin-right: 5px">check_circle</mat-icon>
                          Completada
                        </mat-chip>
                      }
                    </h5>
                    @if (user_permissions().can_edit_board && not_used_company_product_phase_task_time_autocalc_settings.length > 0) {
                      <button mat-icon-button class="small-icon-button" [matMenuTriggerFor]="menu" [ngStyle]="{ 'margin-right': '5px' }">
                        <mat-icon>settings</mat-icon>
                      </button>
                      <mat-menu #menu="matMenu">
                        @for (nu of not_used_company_product_phase_task_time_autocalc_settings; track nu) {
                          <button mat-menu-item (click)="createBudget(nu)">
                            <mat-icon>{{ nu.company_product_phase_task_time_autocalc_setting_category.google_fonts_icon_slug }}</mat-icon>
                            <span>Añadir {{ nu.company_product_phase_task_time_autocalc_setting_category.name }}</span>
                          </button>
                        }
                      </mat-menu>
                    }
                  </div>
                  <ul id="budgets-list">
                    @if (estimation_template_data) {
                      @for (
                        data of estimation_template_data;
                        track data.product_task_board_time_budget
                          ? data.product_task_board_time_budget.id !== 0
                            ? data.product_task_board_time_budget.id
                            : `${data.product_task_board_time_budget.budgetable_type}-${data.product_task_board_time_budget.budgetable_id}`
                          : data.title === 'General'
                            ? 'general'
                            : $index
                      ) {
                        <li [ngClass]="{ 'virtual-budget': data.product_task_board_time_budget?.id === 0 }">
                          <div class="budget-list-header">
                            @if (data.product_task_board_time_budget) {
                              <button
                                mat-icon-button
                                class="small-icon-button"
                                [matMenuTriggerFor]="menu"
                                aria-label="Example icon-button with a menu"
                                [ngStyle]="{ 'margin-right': '5px' }"
                              >
                                <mat-icon>more_vert</mat-icon>
                              </button>
                              <mat-menu #menu="matMenu">
                                @if (
                                  data.title === 'REV' &&
                                  product_task_board() &&
                                  product_task_board()!.company_product_phase_board_col.company_product_phase_board_col_role.slug ===
                                    'under-review' &&
                                  has_other_reviewer
                                ) {
                                  <button
                                    mat-menu-item
                                    class="menu-item-disabled-tooltip"
                                    (click)="reRequestProductTaskBoardReview(product_task_board()!)"
                                    [disabled]="isReRequestReviewDisabled(product_task_board())"
                                    [matTooltip]="getReRequestReviewDisabledReason(product_task_board())"
                                    [matTooltipDisabled]="!isReRequestReviewDisabled(product_task_board())"
                                  >
                                    <mat-icon>manage_search</mat-icon>
                                    <span>Solicitar revisión</span>
                                  </button>
                                }
                                @if (data.is_assigned_to_me) {
                                  <button
                                    mat-menu-item
                                    (click)="chooseNewAssignedUser(data.product_task_board_time_budget, null)"
                                    [disabled]="task.is_completed || is_current_board_old_and_inactive"
                                  >
                                    <mat-icon>person_remove</mat-icon>
                                    <span>Desasignar usuario</span>
                                  </button>
                                } @else if (!task.is_completed && !is_current_board_old_and_inactive) {
                                  <button mat-menu-item (click)="chooseNewAssignedUser(data.product_task_board_time_budget, me)">
                                    <mat-icon>person_add</mat-icon>
                                    <span>Me lo pido</span>
                                  </button>
                                }
                                @if (
                                  data.product_task_board_time_budget.assignee_id &&
                                  !data.is_assigned_to_me &&
                                  data.can_choose_assignee &&
                                  !task.is_completed &&
                                  !is_current_board_old_and_inactive
                                ) {
                                  <button mat-menu-item (click)="chooseNewAssignedUser(data.product_task_board_time_budget, null)">
                                    <mat-icon>person_remove</mat-icon>
                                    <span>Desasignar usuario</span>
                                  </button>
                                }
                                @if (data.product_task_board_time_budget.id !== 0) {
                                  @if (
                                    product_task_board()!.active_product_task_board_time_budget_id === null ||
                                    data.product_task_board_time_budget.id !==
                                      product_task_board()!.active_product_task_board_time_budget_id
                                  ) {
                                    <button
                                      mat-menu-item
                                      (click)="markCategoryAsActive(data.product_task_board_time_budget)"
                                      [disabled]="is_current_board_old_and_inactive || !user_permissions().can_edit_board"
                                    >
                                      <mat-icon>toggle_on</mat-icon>
                                      <span>Marcar categoría como activa</span>
                                    </button>
                                  } @else {
                                    <button
                                      mat-menu-item
                                      (click)="markCategoryAsInactive()"
                                      [disabled]="is_current_board_old_and_inactive || !user_permissions().can_edit_board"
                                    >
                                      <mat-icon>toggle_off</mat-icon>
                                      <span>Marcar categoría como inactiva</span>
                                    </button>
                                  }
                                }
                                @if (data.product_task_board_time_budget.id !== 0) {
                                  @if (!data.product_task_board_time_budget.completed_by_user_id) {
                                    <button
                                      mat-menu-item
                                      (click)="markCategoryAsCompleted(data.product_task_board_time_budget)"
                                      [matTooltip]="is_current_board_future ? 'No se puede completar un budget de un tablero futuro.' : ''"
                                      [disabled]="
                                        task.is_completed ||
                                        is_current_board_old_and_inactive ||
                                        is_current_board_future ||
                                        (!user_permissions().can_edit_board &&
                                          (!user_permissions().can_drag_in_board || !data.is_assigned_to_me))
                                      "
                                    >
                                      <mat-icon>check_circle</mat-icon>
                                      <span>Marcar categoría como completada</span>
                                    </button>
                                  } @else {
                                    <button
                                      mat-menu-item
                                      (click)="markCategoryAsIncomplete(data.product_task_board_time_budget)"
                                      [disabled]="
                                        task.is_completed ||
                                        is_current_board_old_and_inactive ||
                                        (!user_permissions().can_edit_board &&
                                          (!user_permissions().can_drag_in_board || !data.is_assigned_to_me))
                                      "
                                    >
                                      <mat-icon>clear</mat-icon>
                                      <span>Marcar categoría como no completada</span>
                                    </button>
                                  }
                                }
                                @if (data.show_delete_time_budget) {
                                  <button mat-menu-item (click)="deleteTaskBudget(data.product_task_board_time_budget)">
                                    <mat-icon>delete</mat-icon>
                                    <span>Eliminar para este board</span>
                                  </button>
                                }
                              </mat-menu>
                            } @else if (data.product_task_time_budget && data.title !== 'General') {
                              <button
                                mat-icon-button
                                class="small-icon-button"
                                [matMenuTriggerFor]="taskBudgetMenu"
                                [ngStyle]="{ 'margin-right': '5px' }"
                              >
                                <mat-icon>more_vert</mat-icon>
                              </button>
                              <mat-menu #taskBudgetMenu="matMenu">
                                @if (!data.product_task_time_budget.completed_by_user_id) {
                                  <button
                                    mat-menu-item
                                    (click)="markTaskBudgetAsCompleted(data.product_task_time_budget)"
                                    [disabled]="task.is_completed"
                                  >
                                    <mat-icon>check_circle</mat-icon>
                                    <span>Marcar categoría como completada</span>
                                  </button>
                                } @else {
                                  <button
                                    mat-menu-item
                                    (click)="markTaskBudgetAsUncompleted(data.product_task_time_budget)"
                                    [disabled]="task.is_completed"
                                  >
                                    <mat-icon>clear</mat-icon>
                                    <span>Marcar categoría como no completada</span>
                                  </button>
                                }
                              </mat-menu>
                            } @else if (data.title === 'General') {}

                            <h6 class="label">{{ data.title }}</h6>

                            @if (data.product_task_board_time_budget?.id === 0 && !data.should_show_completed_category_icon) {
                              <span class="virtual-budget-badge" matTooltip="Este budget aún no ha sido creado">Virtual</span>
                            }

                            @if (data.product_task_board_time_budget) {
                              @if (data.is_active_budget) {
                                <span class="active">
                                  <mat-icon>autorenew</mat-icon>
                                  <span>Activo</span>
                                </span>
                              }
                              @if (data.should_show_completed_category_icon) {
                                <div class="ask-modifications">
                                  <mat-icon [matTooltip]="data.completed_tooltip">check_circle</mat-icon>
                                </div>
                              }
                            } @else if (data.product_task_time_budget && data.should_show_completed_category_icon) {
                              <div class="ask-modifications">
                                <mat-icon [matTooltip]="data.completed_tooltip">check_circle</mat-icon>
                              </div>
                            }
                          </div>
                          <div class="budget-list-body">
                            @if (data.show_assignee && data.product_task_board_time_budget) {
                              <mat-form-field appearance="outline" class="nobottom noborder">
                                <mat-select
                                  [value]="data.assignee"
                                  (selectionChange)="chooseNewAssignedUser(data.product_task_board_time_budget, $event.value, $event)"
                                  [disabled]="task.is_completed || is_current_board_old_and_inactive || !data.can_choose_assignee"
                                  panelClass="product-task-assignee-select-panel"
                                  panelWidth
                                >
                                  <mat-select-trigger>
                                    @if (!data.assignee) {
                                      ??
                                    } @else {
                                      <app-profile-pic-with-role
                                        [matTooltip]="data.assignee.name + ' ' + data.assignee.surnames"
                                        [user]="data.assignee"
                                      ></app-profile-pic-with-role>
                                    }
                                  </mat-select-trigger>

                                  @for (user of data.available_assignees; track user) {
                                    <mat-option [value]="user">
                                      <app-user-profile-picture
                                        [user]="user"
                                        [css_class]="'profile-image'"
                                        [alt]="user.name + ' ' + user.surnames"
                                      />
                                      {{ user.name + ' ' + user.surnames }}
                                    </mat-option>
                                  }
                                </mat-select>
                              </mat-form-field>
                            }
                            <div class="product-task-spinner">
                              @for (spinner of data.spinners; track $index; let i = $index) {
                                <div
                                  class="spinner"
                                  [class.clickable]="
                                    data.title === 'General' &&
                                    user_permissions().can_edit_backlog &&
                                    !is_current_board_old_and_inactive &&
                                    i === 0
                                  "
                                  [matTooltip]="spinner.tooltip"
                                  [ngClass]="{
                                    'can-register': spinner.can_register,
                                  }"
                                  [attr.role]="
                                    data.title === 'General' &&
                                    user_permissions().can_edit_backlog &&
                                    !is_current_board_old_and_inactive &&
                                    i === 0
                                      ? 'button'
                                      : null
                                  "
                                  [attr.tabindex]="
                                    data.title === 'General' &&
                                    user_permissions().can_edit_backlog &&
                                    !is_current_board_old_and_inactive &&
                                    i === 0
                                      ? 0
                                      : null
                                  "
                                  (click)="
                                    data.title === 'General' &&
                                      user_permissions().can_edit_backlog &&
                                      !is_current_board_old_and_inactive &&
                                      i === 0 &&
                                      openTaskTimeBudgetDialog()
                                  "
                                  (keyup.enter)="
                                    data.title === 'General' &&
                                      user_permissions().can_edit_backlog &&
                                      !is_current_board_old_and_inactive &&
                                      i === 0 &&
                                      openTaskTimeBudgetDialog()
                                  "
                                >
                                  @if (
                                    data.title === 'General' &&
                                    user_permissions().can_edit_backlog &&
                                    !is_current_board_old_and_inactive &&
                                    i === 0
                                  ) {
                                    <span class="spinner-clock-icon" aria-hidden="true">
                                      <mat-icon>schedule</mat-icon>
                                    </span>
                                  }
                                  <mat-progress-spinner
                                    [ngClass]="spinner.class"
                                    [value]="spinner.value"
                                    [diameter]="i === 0 ? 70 : 30"
                                    [strokeWidth]="i === 0 ? 8 : 4"
                                  ></mat-progress-spinner>
                                  <div class="text">
                                    <span>
                                      {{ spinner.text }}
                                    </span>
                                    @if (spinner.can_register && data.product_task_board_time_budget) {
                                      <button mat-icon-button (click)="openTimeTrackingDialog(null, data.product_task_board_time_budget)">
                                        <mat-icon>add</mat-icon>
                                      </button>
                                    }
                                  </div>
                                </div>
                              }
                            </div>
                          </div>
                        </li>
                      }
                    }
                  </ul>
                </div>
              </div>

              <hr />

              <div class="row mb-0" id="tag-wrapper">
                <div class="col">
                  <mat-form-field appearance="outline" class="nobottom noborder">
                    <mat-chip-grid #tagsGrid>
                      @for (tag of tags; track $index) {
                        <mat-chip-row (removed)="removeTag(tag)">
                          {{ tag.length > 22 ? (tag | slice: 0 : 22) + '...' : tag }}
                          <button
                            matChipRemove
                            [attr.aria-label]="'remove ' + tag"
                            [disabled]="!user_permissions().can_edit_backlog || is_current_board_old_and_inactive"
                          >
                            <mat-icon>cancel</mat-icon>
                          </button>
                        </mat-chip-row>
                      }
                    </mat-chip-grid>
                    <input
                      placeholder="Nuevo tag..."
                      #tagInput
                      [formControl]="tags_cntrl"
                      [matChipInputFor]="tagsGrid"
                      [matAutocomplete]="autoTag"
                      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                      (matChipInputTokenEnd)="addTag($event)"
                      [disabled]="task.is_completed || !user_permissions().can_edit_backlog || is_current_board_old_and_inactive"
                    />
                    <mat-autocomplete #autoTag="matAutocomplete" (optionSelected)="selectedTag($event)">
                      @for (tag of filtered_tags | async; track tag) {
                        <mat-option [value]="tag">{{ tag }}</mat-option>
                      }
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
              </div>
              <hr />
              <div class="row mb-0" id="listeners-wrapper">
                <div class="col-lg-6 col-md-12">
                  <h5 class="label">Siguiendo</h5>
                  <div class="d-flex list-profile-pics">
                    @for (r of task.product_task_listeners; track r.id) {
                      <app-profile-pic-with-role
                        [matTooltip]="r.full_name || r.name + ' ' + (r.surnames || '')"
                        [user]="r"
                        [can_remove]="!is_current_board_old_and_inactive && (r.id === me.id || user_permissions().can_edit_backlog)"
                        (userClicked)="removeListener(r)"
                      ></app-profile-pic-with-role>
                    }
                    @if (!imFollowingTask && !is_current_board_old_and_inactive) {
                      <button
                        mat-icon-button
                        class="small-icon-button"
                        matTooltip="Seguir tarea y recibir notificaciones"
                        (click)="addListener(me)"
                      >
                        <mat-icon>add</mat-icon>
                      </button>
                    }
                  </div>
                  @if (user_permissions().can_edit_backlog) {
                    <mat-form-field appearance="outline" class="nobottom noborder">
                      <input
                        type="text"
                        placeholder="Escribe..."
                        matInput
                        [formControl]="listener_user_picker.control"
                        [matAutocomplete]="autoListeners"
                        [disabled]="is_current_board_old_and_inactive"
                      />
                      <mat-autocomplete
                        #autoListeners="matAutocomplete"
                        panelWidth="320px"
                        panelClass="product-task-user-autocomplete-panel"
                        [autoActiveFirstOption]="listener_user_picker.auto_active_create"
                        (optionSelected)="onUserPickerSelected('listeners', $event)"
                      >
                        @if (listener_user_picker.create_typed_name) {
                          <mat-option [value]="create_user_option_value">
                            <mat-icon>add</mat-icon>
                            Crear usuario con más datos
                          </mat-option>
                          @if (listener_user_picker.has_filtered) {
                            <mat-divider></mat-divider>
                          }
                        }
                        @for (item of listener_user_picker.filtered_users$ | async; track item.id) {
                          <mat-option [value]="item" class="product-task-user-option">
                            <span class="product-task-user-option-content">
                              <span class="product-task-user-option-name">{{
                                item.full_name || item.name + ' ' + (item.surnames || '')
                              }}</span>
                              @if (item.role?.name) {
                                <span class="product-task-user-option-role">{{ item.role.name }}</span>
                              }
                            </span>
                          </mat-option>
                        }
                      </mat-autocomplete>
                    </mat-form-field>
                  }
                </div>
                <div class="col-lg-6 col-md-12">
                  <h5 class="label">Solicitado por</h5>
                  <div class="d-flex list-profile-pics">
                    @for (requester of task.product_task_requesters; track requester.id) {
                      <app-profile-pic-with-role
                        [matTooltip]="requester.full_name || requester.name + ' ' + (requester.surnames || '')"
                        [user]="requester"
                        [can_remove]="!is_current_board_old_and_inactive && !is_client && user_permissions().can_edit_backlog"
                        (userClicked)="removeRequester(requester)"
                      ></app-profile-pic-with-role>
                    }
                    @if (!imTaskRequester && !is_current_board_old_and_inactive && !is_client && user_permissions().can_edit_backlog) {
                      <button mat-icon-button class="small-icon-button" matTooltip="Marcarme como solicitante" (click)="addRequester(me)">
                        <mat-icon>add</mat-icon>
                      </button>
                    }
                  </div>
                  @if (!is_client && user_permissions().can_edit_backlog) {
                    <mat-form-field appearance="outline" class="nobottom noborder">
                      <input
                        type="text"
                        placeholder="Escribe..."
                        matInput
                        [formControl]="requester_user_picker.control"
                        [matAutocomplete]="product_task_request_control"
                        [disabled]="is_current_board_old_and_inactive"
                      />
                      <mat-autocomplete
                        #product_task_request_control="matAutocomplete"
                        panelWidth="320px"
                        panelClass="product-task-user-autocomplete-panel"
                        [autoActiveFirstOption]="requester_user_picker.auto_active_create"
                        (optionSelected)="onUserPickerSelected('requesters', $event)"
                      >
                        @if (requester_user_picker.create_typed_name) {
                          <mat-option [value]="create_user_option_value">
                            <mat-icon>add</mat-icon>
                            Crear usuario con más datos
                          </mat-option>
                          @if (requester_user_picker.has_filtered) {
                            <mat-divider></mat-divider>
                          }
                        }
                        @for (item of requester_user_picker.filtered_users$ | async; track item.id) {
                          <mat-option [value]="item" class="product-task-user-option">
                            <span class="product-task-user-option-content">
                              <span class="product-task-user-option-name">{{
                                item.full_name || item.name + ' ' + (item.surnames || '')
                              }}</span>
                              @if (item.role?.name) {
                                <span class="product-task-user-option-role">{{ item.role.name }}</span>
                              }
                            </span>
                          </mat-option>
                        }
                      </mat-autocomplete>
                    </mat-form-field>
                  }
                </div>
              </div>
              <hr />
              <small>Creada el {{ task.created_at | date: 'long' }}</small>
              <small>Actualizada el {{ task.updated_at | date: 'long' }}</small>
              <small>Creada por {{ task.creator?.full_name || 'Desconocido' }}</small>
            </aside>
          </section>
        </ngx-dropzone>
      </mat-dialog-content>
    </div>
  </div>
}
@if (!isTaskLoaded) {
  <mat-dialog-content>
    <img style="width: 100%" src="assets/img/loadingTask.png" />
  </mat-dialog-content>
}
